(function () {
  function qa(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }
  function q(sel, root)  { return (root || document).querySelector(sel); }

  // Set *all* matching radios (there are two sets on your page)
  function setAllRadiosByName(scope, optName, optValue) {
    const sel = `input[type="radio"][name="${CSS.escape(optName)}"][value="${CSS.escape(optValue)}"]`;
    const matches = qa(sel, scope);
    let touched = false;
    matches.forEach(input => {
      if (!input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        touched = true;
      }
    });
    return touched || matches.length > 0;
  }

  // Robustly find the visible pill element used for styling
  function findSwatchInner(input) {
    return input.nextElementSibling?.matches('.\\#form-swatch-inner, .\\#form-color-swatch-inner, .\\#form-swatch')
      ? input.nextElementSibling
      : input.closest('label')?.querySelector('.\\#form-swatch-inner, .\\#form-color-swatch-inner, .\\#form-swatch');
  }

  function setRadioByName(scope, optName, optValue) {
    const input = q(`input[type="radio"][name="${CSS.escape(optName)}"][value="${CSS.escape(optValue)}"]`, scope);
    if (!input) return false;
    input.checked = true;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function setVariantId(scope, variantId) {
    const idInput = q('[data-variant-id-input]', scope);
    if (!idInput) return false;
    idInput.disabled = false;
    idInput.value = String(variantId);
    idInput.dispatchEvent(new Event('change', { bubbles: true }));
    // Generic event many themes respond to
    const pf = q('product-form', scope) || document;
    pf.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: { id: Number(variantId) } } }));
    return true;
  }

  function getCheckedValue(scope, name) {
    const el = q(`input[type="radio"][name="${CSS.escape(name)}"]:checked`, scope);
    return el ? el.value : null;
  }

  function updateHarvestHeader(block, section, harvestName) {
    const el = block.querySelector('[data-swatch-value]');  // span inside the Harvest header
    if (!el) return;
    const val = getCheckedValue(section, harvestName);
    if (val) el.textContent = val;
  }

  function upsertSoldoutIcon(cell, isSoldOut) {
    let icon = cell.querySelector('.variant-matrix__soldout-icon');
    let sr   = cell.querySelector('.sr-only');

    if (isSoldOut) {
      if (!icon) {
        icon = document.createElement('span');
        icon.className = 'variant-matrix__soldout-icon';
        icon.setAttribute('aria-hidden', 'true');
        cell.appendChild(icon);
      }
      if (!sr) {
        sr = document.createElement('span');
        sr.className = 'sr-only';
        sr.textContent = 'Sold out';
        cell.appendChild(sr);
      }
    } else {
      if (icon) icon.remove();
      if (sr)   sr.remove();
    }
  }

  function syncHarvestSwatchStyles(section, harvestName) {
    qa(`input[type="radio"][name="${CSS.escape(harvestName)}"]`, section).forEach(inp => {
      const inner = findSwatchInner(inp);
      if (!inner) return;
      inner.classList.toggle('is-checked', inp.checked);
      // optional: also mirror the class on the label, in case CSS targets label.is-checked
      const lbl = inp.closest('label');
      if (lbl) lbl.classList.toggle('is-checked', inp.checked);
    });
  }

  // Find the visible pill next to a radio (your swatch snippet)
  function findSwatchInner(input) {
    return input.nextElementSibling?.matches('.\\#form-swatch-inner, .\\#form-color-swatch-inner, .\\#form-swatch')
      ? input.nextElementSibling
      : input.closest('label')?.querySelector('.\\#form-swatch-inner, .\\#form-color-swatch-inner, .\\#form-swatch');
  }

  // Persist the green outline on the selected Harvest pill
  function syncHarvestSwatchStyles(section, harvestName) {
    Array.from(section.querySelectorAll(`input[type="radio"][name="${CSS.escape(harvestName)}"]`)).forEach(inp => {
      const inner = findSwatchInner(inp);
      const lbl = inp.closest('label');
      if (inner) inner.classList.toggle('is-checked', inp.checked);
      if (lbl)   lbl.classList.toggle('is-checked', inp.checked);
    });
  }

  // Set *all* duplicated radios (you have two sets: native + visible)
  function setAllRadiosByName(section, optName, optValue) {
    const sel = `input[type="radio"][name="${CSS.escape(optName)}"][value="${CSS.escape(optValue)}"]`;
    let touched = false;
    Array.from(section.querySelectorAll(sel)).forEach(input => {
      if (!input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        touched = true;
      }
    });
    return touched;
  }

  // Get the row label for a given cell ("1 oz.", "1/4 lb.", etc.)
  function getRowLabelForCell(cell) {
    const rowEl = cell.closest('.variant-matrix__row');
    return rowEl?.querySelector('.variant-matrix__row-header')?.textContent.trim() || '';
  }

  // Find a row element by label text
  function findRowElByLabel(block, rowLabel) {
    return Array.from(block.querySelectorAll('.variant-matrix__row'))
      .find(r => r.querySelector('.variant-matrix__row-header')?.textContent.trim() === rowLabel);
  }

  // Find the cell in a row by column label
  function findCellInRowByCol(rowEl, colLabel) {
    return rowEl ? rowEl.querySelector(`.variant-matrix__cell[data-col="${CSS.escape(colLabel)}"]`) : null;
  }

  // First available cell in a row (exists=true & not sold out)
  function findFirstAvailableInRow(rowEl) {
    return Array.from(rowEl?.querySelectorAll('.variant-matrix__cell') || [])
      .find(c => c.dataset.exists === 'true' && c.dataset.soldout !== 'true') || null;
  }

  // Press/select a cell, update radios + variant id, and remember row/col
  function selectMatrixCell(block, section, cell, harvestName, colName, rowName) {
    if (!cell) return;

    // Update radios (Harvest is already chosen, but we set it on both sets just in case)
    const rowVal = getRowLabelForCell(cell);
    setAllRadiosByName(section, harvestName, getCheckedValue(section, harvestName) || '');
    setAllRadiosByName(section, colName, cell.dataset.col);
    setAllRadiosByName(section, rowName, rowVal);

    // Set the variant id (even if sold out — ATC will be disabled by theme)
    if (cell.dataset.variantId) setVariantId(section, cell.dataset.variantId);

    // Press state
    Array.from(block.querySelectorAll('.variant-matrix__cell[aria-pressed="true"]'))
        .forEach(el => el.setAttribute('aria-pressed', 'false'));
    cell.setAttribute('aria-pressed', 'true');

    // Remember last selected coordinates (for future Harvest changes)
    block.dataset.selectedRow = rowVal;
    block.dataset.selectedCol = cell.dataset.col;

    // Keep UI bits in sync
    syncHarvestSwatchStyles(section, harvestName);
    updateHarvestHeader(block, section, harvestName);
  }

  function renderMatrix(block) {
    const section = block.closest('[id^="shopify-section-"]') || document;
    const matrix = q('.variant-matrix', block);
    const dataTag = q('.variant-matrix-data', block);
    if (!matrix || !dataTag) return;

    const map = JSON.parse(dataTag.textContent).map || {};
    const harvestName = matrix.dataset.harvestName;
    const colName = matrix.dataset.colName;
    const rowName = matrix.dataset.rowName;
    const harvestVal = getCheckedValue(section, harvestName);

    // Rebind every cell to the current harvest selection
    qa('.variant-matrix__row', block).forEach(rowEl => {
      const rowLabel = q('.variant-matrix__row-header', rowEl)?.textContent.trim();
      qa('.variant-matrix__cell', rowEl).forEach(cell => {
        const colLabel = cell.dataset.col;
        const key = `${harvestVal}|||${colLabel}|||${rowLabel}`;
        const entry = map[key];

        if (entry) {
          // Exists for this harvest
          cell.dataset.exists   = 'true';
          cell.dataset.variantId = entry.id;
          const isSoldOut = !entry.available;
          cell.dataset.soldout  = isSoldOut ? 'true' : 'false';
          cell.removeAttribute('disabled');

          // Price text
          const priceEl = q('.variant-matrix__cell-price', cell);
          if (priceEl) priceEl.textContent = entry.price;

          // Icon toggle
          upsertSoldoutIcon(cell, isSoldOut);
        } else {
          // Non-existent combo for this harvest
          cell.dataset.exists   = 'false';
          cell.dataset.variantId = '';
          cell.dataset.soldout  = 'false';
          cell.setAttribute('disabled', 'disabled');

          const priceEl = q('.variant-matrix__cell-price', cell);
          if (priceEl) priceEl.textContent = '—';

          // Ensure no icon remains
          upsertSoldoutIcon(cell, false);
        }
      });
    });

    // Update pressed-state to follow the currently selected variant id
    const idInput = q('[data-variant-id-input]', section);
    const currentId = idInput && idInput.value;
    qa('.variant-matrix__cell[aria-pressed="true"]', block).forEach(el => el.setAttribute('aria-pressed', 'false'));
    if (currentId) {
      const hit = q(`.variant-matrix__cell[data-variant-id="${CSS.escape(currentId)}"]`, block);
      if (hit) hit.setAttribute('aria-pressed', 'true');
    }
  }

  function init(block) {
    const section = block.closest('[id^="shopify-section-"]') || document;
    const matrix = q('.variant-matrix', block);
    if (!matrix) return;

    const harvestName = matrix.dataset.harvestName;
    const colName = matrix.dataset.colName;
    const rowName = matrix.dataset.rowName;

    // Initial render
    renderMatrix(block);
    updateHarvestHeader(block, section, harvestName);
    syncHarvestSwatchStyles(section, harvestName);

    // When Harvest changes (user clicks a different swatch), re-render
    section.addEventListener('change', (e) => {
      const t = e.target;
      if (t && t.matches(`input[type="radio"][name="${CSS.escape(harvestName)}"]`)) {
        // Mirror the chosen Harvest to *all* duplicate radio sets
        setAllRadiosByName(section, harvestName, t.value);
        renderMatrix(block);
        updateHarvestHeader(block, section, harvestName);
        syncHarvestSwatchStyles(section, harvestName);
      }
    });

    // If the theme fires a variant change event, sync the pressed state
    document.addEventListener('variant:change', () => {
      renderMatrix(block);
      syncHarvestSwatchStyles(section, harvestName);
      updateHarvestHeader(block, section, harvestName);
    });

    // Clicking a matrix cell selects the variant
    block.addEventListener('click', (e) => {
      const cell = e.target.closest('.variant-matrix__cell');
      if (!cell) return;
      if (cell.dataset.exists === 'false') return; // non-existent combo stays disabled

      // 1) Ensure BOTH Harvest radio sets reflect the active value
      const harvestVal = getCheckedValue(section, harvestName);
      if (harvestVal) setAllRadiosByName(section, harvestName, harvestVal);

      // 2) Set Flower / Bag on all matching radios too
      setAllRadiosByName(section, colName, cell.dataset.col);
      setAllRadiosByName(section, rowName, cell.dataset.row);

      // Keep header text + green outline in sync
      syncHarvestSwatchStyles(section, harvestName);
      updateHarvestHeader(block, section, harvestName);

      // 3) Also set the variant id as a fallback (keeps ATC working for sold-out combos)
      if (cell.dataset.variantId) setVariantId(section, cell.dataset.variantId);

      // 4) Update pressed state
      qa('.variant-matrix__cell[aria-pressed="true"]', block).forEach(el => el.setAttribute('aria-pressed', 'false'));
      cell.setAttribute('aria-pressed', 'true');
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.variant-matrix-block').forEach(init);
  });
})();
